import { JsonObject, JsonProperty } from 'json2typescript';
import Faq from '@/models/faq/Faq';

/**
 * よくあるご質問保持クラス
 */
@JsonObject('Faqs')
export default class Faqs {
  constructor() {
    this.categoryTitle = undefined;
    this.order = undefined;
    this.faq = new Array<Faq>();
  }

  @JsonProperty('category_title')
  public categoryTitle?: string;

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('faq')
  public faq: Array<Faq>;
}
